/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_UnlockInputs */

const cs_workflow_unlock = /** @type {(inputs: Workflow_UnlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odemknout`)
};

const en_workflow_unlock = /** @type {(inputs: Workflow_UnlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlock`)
};

/**
* | output |
* | --- |
* | "Unlock" |
*
* @param {Workflow_UnlockInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_unlock = /** @type {((inputs?: Workflow_UnlockInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_UnlockInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_unlock(inputs)
	return cs_workflow_unlock(inputs)
});